import { render, staticRenderFns } from "./showBoth.vue?vue&type=template&id=29cc52cf&scoped=true"
import script from "./showBoth.vue?vue&type=script&lang=js"
export * from "./showBoth.vue?vue&type=script&lang=js"
import style0 from "./showBoth.vue?vue&type=style&index=0&id=29cc52cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cc52cf",
  null
  
)

export default component.exports